import React, { Component } from 'react';

import Breadcrumb from '../UI/Breadcrumb';
import CustomerForm from './CustomerForm';


class AddCustomer extends Component {
    render() {
        return (
            <React.Fragment>
                <div className="page-title">
                    <div className="container">
                        <div className="row flex-center-y justify-between">
                            <div className="col-xs-12 text-center">
                                <h1 className="color-grey capitalize">Add new customer</h1>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="container">
                    <Breadcrumb from={[{link: '/customers', label: 'Customers list'}]}
                                current="Add New Customer"/>
                </div>

                <div className="container box inner-padding mb-15">
                    <CustomerForm history={this.props.history}/>
                </div>
            </React.Fragment>
        );
    }
}

export default AddCustomer;



// WEBPACK FOOTER //
// ./src/components/Customer-administrator/AddCustomer.js